import React from 'react';
import { Users } from 'lucide-react';
import ClientCard from './ClientCard';

const ClientList = ({ 
  filteredClients, 
  expandedClient, 
  toggleClientExpand, 
  handleOpenInClientInsights,
  processInterests,
  clearFilters,
  searchSource,
  isLoading
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full"></div>
        <span className="ml-3 text-gray-600">Loading clients...</span>
      </div>
    );
  }

    if (filteredClients.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
        <Users size={48} className="mx-auto text-gray-400 mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-1">No clients found</h3>
        <p className="text-sm text-gray-500 mb-4">Try adjusting your filters or search query</p>
        <button
          onClick={clearFilters}
          className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 transition-colors"
        >
          Clear All Filters
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {filteredClients.map(client => (
        <ClientCard
          key={client.id}
          client={client}
          expandedClient={expandedClient}
          toggleClientExpand={toggleClientExpand}
          handleOpenInClientInsights={handleOpenInClientInsights}
          processInterests={processInterests}
        />
      ))}
    </div>
  );
};

export default ClientList;